import { ApplicationStatus } from 'api/btlApplicationForm/types';
import { BtlApplicationFormPageEnum } from './types';

export const ALL_STEPS_WITHOUT_DOCUMENTS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS_WITHOUT_COMMUNICATION_AND_DOCUMENTS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER_AND_COMMUNICATION: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
];

export const ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
];

export const ALL_STEPS_WITHOUT_POST_OFFER: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
  BtlApplicationFormPageEnum.VALUATION,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const ALL_STEPS: BtlApplicationFormPageEnum[] = [
  BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
  BtlApplicationFormPageEnum.APPLICANTS,
  BtlApplicationFormPageEnum.PRODUCT,
  BtlApplicationFormPageEnum.TOP_SLICING,
  BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  BtlApplicationFormPageEnum.SOLICITORS,
  BtlApplicationFormPageEnum.BANK_DETAILS,
  BtlApplicationFormPageEnum.COMMUNICATION,
  BtlApplicationFormPageEnum.DOCUMENTS,
  BtlApplicationFormPageEnum.VALUATION,
  BtlApplicationFormPageEnum.POST_OFFER,
  BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION,
];

export const STATUS_TO_STEPS: Partial<Record<ApplicationStatus, BtlApplicationFormPageEnum[]>> = {
  [ApplicationStatus.NEW]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.TOP_SLICING,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
    BtlApplicationFormPageEnum.SUBMIT_DIP,
  ],
  [ApplicationStatus.DIP_SUBMITTED]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.TOP_SLICING,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  ],
  [ApplicationStatus.REVIEWING_DIP]: [
    BtlApplicationFormPageEnum.FINANCING_AND_PROPERTY,
    BtlApplicationFormPageEnum.APPLICANTS,
    BtlApplicationFormPageEnum.PRODUCT,
    BtlApplicationFormPageEnum.TOP_SLICING,
    BtlApplicationFormPageEnum.AFFORDABILITY_CHECK,
  ],
  [ApplicationStatus.DIP_ACCEPTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER_AND_COMMUNICATION,
  [ApplicationStatus.DIP_DECLINED]: ALL_STEPS_WITHOUT_DOCUMENTS,
  [ApplicationStatus.DIP_EXPIRED]: ALL_STEPS_WITHOUT_DOCUMENTS,
  [ApplicationStatus.APPLICATION_SUBMITTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.RECOMMENDED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.FIS_ISSUED]: ALL_STEPS_WITHOUT_VALUATION_AND_POST_OFFER,
  [ApplicationStatus.FEES_PAID]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.REVIEWING_APPLICATION]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_ISSUED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_BEING_REVISED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.OFFER_ACCEPTED]: ALL_STEPS,
  [ApplicationStatus.OFFER_EXPIRED]: ALL_STEPS_WITHOUT_POST_OFFER,
  [ApplicationStatus.APPLICATION_DECLINED]: ALL_STEPS,
  [ApplicationStatus.COMPLETION]: ALL_STEPS,
};

export const STATUS_TO_LABELS: Partial<Record<ApplicationStatus, string>> = {
  [ApplicationStatus.NEW]: 'New',
  [ApplicationStatus.DIP_SUBMITTED]: 'DIP Submitted',
  [ApplicationStatus.REVIEWING_DIP]: 'Reviewing DIP',
  [ApplicationStatus.DIP_ACCEPTED]: 'DIP Accepted',
  [ApplicationStatus.DIP_DECLINED]: 'DIP Declined',
  [ApplicationStatus.DIP_EXPIRED]: 'DIP Expired',
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: 'BTL Application Submitted',
  [ApplicationStatus.FIS_ISSUED]: 'FIS Issued',
  [ApplicationStatus.FEES_PAID]: 'Fees Paid',
  [ApplicationStatus.REVIEWING_APPLICATION]: 'Reviewing Application',
  [ApplicationStatus.OFFER_ISSUED]: 'Offer Issued',
  [ApplicationStatus.OFFER_ACCEPTED]: 'Offer Accepted',
  [ApplicationStatus.OFFER_EXPIRED]: 'Offer Expired',
  [ApplicationStatus.APPLICATION_DECLINED]: 'Application Declined',
  [ApplicationStatus.COMPLETION]: 'Completion',
};

export const STATUS_TO_CAN_RUN_AFFORDABILITY: Partial<Record<ApplicationStatus, boolean>> = {
  [ApplicationStatus.NEW]: true,
  [ApplicationStatus.DIP_SUBMITTED]: false,
  [ApplicationStatus.REVIEWING_DIP]: false,
  [ApplicationStatus.DIP_ACCEPTED]: true,
  [ApplicationStatus.DIP_DECLINED]: false,
  [ApplicationStatus.DIP_EXPIRED]: false,
  [ApplicationStatus.BTL_APPLICATION_SUBMITTED]: false,
  [ApplicationStatus.FIS_ISSUED]: false,
  [ApplicationStatus.FEES_PAID]: false,
  [ApplicationStatus.REVIEWING_APPLICATION]: false,
  [ApplicationStatus.OFFER_ISSUED]: false,
  [ApplicationStatus.OFFER_ACCEPTED]: false,
  [ApplicationStatus.OFFER_EXPIRED]: false,
  [ApplicationStatus.APPLICATION_DECLINED]: false,
  [ApplicationStatus.COMPLETION]: false,
};

export const isDipAcceptedOrLater = (status?: ApplicationStatus): boolean => {
  if (!status) return false;

  const statusesDipAcceptedAndAfter: ApplicationStatus[] = [
    ApplicationStatus.DIP_ACCEPTED,
    ApplicationStatus.AWAITING_PROPERTY,
    ApplicationStatus.PROPERTY_SUBMITTED,
    ApplicationStatus.BOOKING_PRE_ADVICE,
    ApplicationStatus.PRE_ADVICE_BOOKED,
    ApplicationStatus.ADVICE_BOOKED,
    ApplicationStatus.PRODUCT_NOT_SUITABLE,
    ApplicationStatus.RECOMMENDED,
    ApplicationStatus.FIS_ISSUED,
    ApplicationStatus.PAYMENT_DUE,
    ApplicationStatus.APPLICATION_SUBMITTED,
    ApplicationStatus.BTL_APPLICATION_SUBMITTED,
    ApplicationStatus.FEES_PAID,
    ApplicationStatus.REVIEWING_APPLICATION,
    ApplicationStatus.PROPERTY_DECLINED,
    ApplicationStatus.APPLICATION_DECLINED,
    ApplicationStatus.OFFER_ISSUED,
    ApplicationStatus.OFFER_ACCEPTED,
    ApplicationStatus.OFFER_EXPIRED,
    ApplicationStatus.OFFER_BEING_REVISED,
    ApplicationStatus.COMPLETION,
  ];

  return statusesDipAcceptedAndAfter.includes(status);
};

export function shouldShowFullBtlApplicationAssertions(status?: ApplicationStatus): boolean {
  if (!status) {
    return false;
  }

  if (status === ApplicationStatus.DIP_DECLINED || status === ApplicationStatus.DIP_EXPIRED) {
    return true;
  }

  return isDipAcceptedOrLater(status);
}

export const isApplicationSubmittedOrLater = (status?: ApplicationStatus): boolean => {
  if (!status) return false;

  const statusesApplicationSubmittedAndAfter: ApplicationStatus[] = [
    ApplicationStatus.APPLICATION_SUBMITTED,
    ApplicationStatus.BTL_APPLICATION_SUBMITTED,
    ApplicationStatus.FIS_ISSUED,
    ApplicationStatus.PAYMENT_DUE,
    ApplicationStatus.FEES_PAID,
    ApplicationStatus.REVIEWING_APPLICATION,
    ApplicationStatus.PROPERTY_DECLINED,
    ApplicationStatus.APPLICATION_DECLINED,
    ApplicationStatus.OFFER_ISSUED,
    ApplicationStatus.OFFER_ACCEPTED,
    ApplicationStatus.OFFER_EXPIRED,
    ApplicationStatus.OFFER_BEING_REVISED,
    ApplicationStatus.COMPLETION,
  ];

  return statusesApplicationSubmittedAndAfter.includes(status);
};

export const hasValuationStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.VALUATION) ?? false;
};

export const hasPostOfferStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.POST_OFFER) ?? false;
};

export const getValuationStepIndex = (status?: ApplicationStatus, isTopSlicing?: boolean): number | undefined => {
  if (!status || !hasValuationStep(status)) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  const hasDocuments = hasDocumentsStep(status);
  const hasCommunication = isApplicationSubmittedOrLater(status);

  if (hasCommunication) {
    currentIndex += 1;
  }

  if (hasDocuments) {
    currentIndex += 1;
  }

  return currentIndex + 1;
};

export const getPostOfferStepIndex = (status?: ApplicationStatus, isTopSlicing?: boolean): number | undefined => {
  if (!status || !hasPostOfferStep(status)) return undefined;

  const valuationIndex = getValuationStepIndex(status, isTopSlicing);
  if (!valuationIndex) return undefined;

  return valuationIndex + 1;
};

export const hasDocumentsStep = (status?: ApplicationStatus): boolean => {
  if (!status) return false;
  const steps = STATUS_TO_STEPS[status];
  return steps?.includes(BtlApplicationFormPageEnum.DOCUMENTS) ?? false;
};

export const getNextStep = (
  currentStep: BtlApplicationFormPageEnum,
  status?: ApplicationStatus,
): BtlApplicationFormPageEnum | undefined => {
  if (!status) return undefined;
  const steps = STATUS_TO_STEPS[status];
  if (!steps) return undefined;

  if (currentStep === BtlApplicationFormPageEnum.BANK_DETAILS) {
    if (steps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    if (steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < steps.length - 1) {
      return steps[currentIndex + 1];
    }
    return undefined;
  }

  if (currentStep === BtlApplicationFormPageEnum.COMMUNICATION) {
    if (steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    if (steps.includes(BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION)) {
      return BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION;
    }
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < steps.length - 1) {
      return steps[currentIndex + 1];
    }
    return undefined;
  }

  if (currentStep === BtlApplicationFormPageEnum.DOCUMENTS) {
    if (steps.includes(BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION)) {
      return BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION;
    }
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex !== -1 && currentIndex < steps.length - 1) {
      return steps[currentIndex + 1];
    }
    return undefined;
  }

  const currentIndex = steps.indexOf(currentStep);
  if (currentIndex === -1 || currentIndex === steps.length - 1) return undefined;

  return steps[currentIndex + 1];
};

export const getPreviousStep = (
  currentStep: BtlApplicationFormPageEnum,
  status?: ApplicationStatus,
): BtlApplicationFormPageEnum | undefined => {
  if (!status) return undefined;
  const steps = STATUS_TO_STEPS[status];
  if (!steps) return undefined;

  if (currentStep === BtlApplicationFormPageEnum.COMMUNICATION) {
    return BtlApplicationFormPageEnum.BANK_DETAILS;
  }

  if (currentStep === BtlApplicationFormPageEnum.DOCUMENTS) {
    if (steps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    return BtlApplicationFormPageEnum.BANK_DETAILS;
  }

  if (currentStep === BtlApplicationFormPageEnum.ADDITIONAL_INFORMATION) {
    if (hasPostOfferStep(status)) {
      return BtlApplicationFormPageEnum.POST_OFFER;
    }
    if (hasValuationStep(status)) {
      return BtlApplicationFormPageEnum.VALUATION;
    }
    if (steps.includes(BtlApplicationFormPageEnum.DOCUMENTS)) {
      return BtlApplicationFormPageEnum.DOCUMENTS;
    }
    if (steps.includes(BtlApplicationFormPageEnum.COMMUNICATION)) {
      return BtlApplicationFormPageEnum.COMMUNICATION;
    }
    const currentIndex = steps.indexOf(currentStep);
    if (currentIndex > 0) {
      return steps[currentIndex - 1];
    }
    return undefined;
  }

  const currentIndex = steps.indexOf(currentStep);
  if (currentIndex <= 0) return undefined;

  return steps[currentIndex - 1];
};

export const getDocumentsStepIndex = (status?: ApplicationStatus, isTopSlicing?: boolean): number | undefined => {
  if (!status) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  const hasCommunication = isApplicationSubmittedOrLater(status);
  if (hasCommunication) {
    currentIndex += 1;
  }

  return currentIndex + 1;
};

export const getAdditionalInformationStepIndex = (
  status?: ApplicationStatus,
  isTopSlicing?: boolean,
): number | undefined => {
  if (!status) return undefined;

  const bankDetailsIndex = isTopSlicing ? 6 : 5;
  let currentIndex = bankDetailsIndex;

  const hasDocuments = hasDocumentsStep(status);
  const hasCommunication = isApplicationSubmittedOrLater(status);

  if (hasCommunication) {
    currentIndex += 1;
  }

  if (hasDocuments) {
    currentIndex += 1;
  }

  if (hasValuationStep(status)) {
    currentIndex += 1;
    if (hasPostOfferStep(status)) {
      currentIndex += 1;
    }
  }

  return currentIndex + 1;
};
